import { useRef, useState } from "react";
import { IPermissionProps } from "../../models/Login";
import { EmptyTaskType, Table } from "./Table";
import Form from "./Form";
import { Toast } from "primereact/toast";


export interface ILegalTaskType {
  task_Id?: number;
  task_Type: string;
}


export interface IModel {
    open: boolean,
    singleData: ILegalTaskType
}

export const LegalTaskType = (permissions: IPermissionProps) => {

 const [modal, setModal] = useState({ singleData: EmptyTaskType, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => { 
        setModal({ singleData: EmptyTaskType, open: false })
    };


    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload}></Table>
            <Toast ref={toast} />
        </>
    )
};
